module.exports = __webpack_public_path__ + "static/media/mg.56421257.svg";